import React from "react";
import { Storefront, Cross, Briefcase, Buildings, Bank, Handshake } from "@phosphor-icons/react";

const SECTORS = [
  { icon: Storefront,  label: "Small businesses" },
  { icon: Handshake,   label: "Nonprofits" },
  { icon: Briefcase,   label: "Contractors" },
  { icon: Cross,       label: "Medical offices" },
  { icon: Buildings,   label: "Retail stores" },
  { icon: Bank,        label: "Professional services" },
];

export default function SocialProof() {
  return (
    <section
      data-testid="social-proof-section"
      className="bg-zinc-50 py-14 md:py-16 border-y border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-xs font-semibold uppercase tracking-widest text-blue-600">
          Trusted across North Carolina
        </div>
        <h3 className="mt-2 font-heading text-2xl sm:text-3xl font-bold text-zinc-900">
          Trusted by North Carolina businesses.
        </h3>
        <p className="mt-3 text-zinc-600 max-w-2xl mx-auto text-[15px]">
          Supporting small businesses, nonprofits, contractors, medical offices, retail stores, and
          professional service firms across North Carolina.
        </p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 max-w-5xl mx-auto">
          {SECTORS.map(({ icon: Icon, label }, i) => (
            <div
              key={label}
              data-testid={`sector-${i}`}
              className="flex flex-col items-center justify-center gap-2 py-5 px-3 rounded-xl border border-zinc-200 bg-white text-zinc-700 hover:border-blue-300 hover:text-blue-700 transition-colors"
            >
              <Icon size={22} weight="duotone" className="text-blue-600" />
              <span className="text-xs sm:text-sm font-semibold leading-tight text-center">{label}</span>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-zinc-500">
          Are you a TechConnect client? <a href="mailto:techconnectncllc@gmail.com" className="text-blue-600 hover:underline">Email us to add your logo</a>.
        </p>
      </div>
    </section>
  );
}
